<template>
  <div class="seek">
    <Dropdown class="pull-left seekDropdown" v-if="Object.keys(seekDropdown.list).length != 1"> 
      <button data-role="trigger" class="btn btn-default dropdown-toggle hui-dropdown-toggle" type="button">
        <span>{{seekLan.dropdown[seekDropdown.active]}}</span>
        <span class="caret"></span>
      </button>
      <template slot="dropdown" v-for="(item,index) in seekLan.dropdown" v-if="seekDropdown.list[index]">
        <li @click="setSeekDropdown(index)" ><a href="#">{{item}}</a></li>
      </template>
    </Dropdown>
    <div v-else class="pull-left seekDropdown dropdown">
      <button class="btn btn-default dropdown-toggle hui-dropdown-toggle no-pointer" type="button">
        <span>{{seekLan.dropdown[seekDropdown.active]}}</span>
      </button>
    </div>
    <div class="pull-left form-group">
      <input type="text" class="form-control hui-form-control" v-model="seekDropdown.seekStr" @keyup.enter="emitSeek" :placeholder="seekLan.seek">
    </div>
    <div v-if="!hideBtn" class="pull-left btn btn-default btn-primary" @click="emitSeek">{{seekLan.seek}}</div>
    <div class="clear"></div>
  </div>
</template>

<script>
  import { Dropdown } from "uiv"
  import { mapState } from "vuex"

  export default { // :class="'hide': Object.keys(seekDropdown.list).length == 1"
    props: [
      "seekDropdown",
      "hideBtn",
    ],
    data () {
      return {}
    },
    mounted () {
    },
    computed: {
      seekLan () {
        return this.translate(this.LANGUAGE, "commissionSeek")
      },
      ...mapState(["LANGUAGE"])
    },
    methods: {
      emitSeek () {
        this.$emit("seek", this.seekDropdown.seekStr)
      },
      setSeekDropdown (index) {
        if (this.$parent.seekDropdownProps) {
          this.$parent.seekDropdownProps.active = index
        } else if (this.$parent.seekDropdown) {
          this.$parent.seekDropdown.active = index
        }
      }
    },
    components: {
      Dropdown
    }
  }
</script>

<style lang="scss" type="text/scss">
  .seek{
    display: inline-block;
    vertical-align: top;
    font-size: 0;
    .seekDropdown{
      display: inline-block;
      vertical-align: top;
      font-size: 13px;
      .dropdown-toggle{
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }
    }
    .form-group{
      display: inline-block;
      vertical-align: top;
      position: relative;
      margin: 0;
      .form-control{
        min-width: 145px;
        font-size: 13px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    .btn-default{
      display: inline-block;
      vertical-align: top;
      font-size: 13px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
</style>





// WEBPACK FOOTER //
// commissionSeek.vue?5f81c085